import React from "react";

const LoadingScreen = ({ message = "Cargando..." }) => {
  return (
    <div className="App">
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p className="text-sm sm:text-base">{message}</p>
      </div>
    </div>
  );
};

export default LoadingScreen; 